import { CHAT_MESSAGE } from '../actions/actionTypes';

const initialState = {
  chatData: [],
};

const chat = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    if (action.type === CHAT_MESSAGE) {
      return {
        ...state,
        chatData: action.payload,
      };
    } else {
      return state;
    }
  }
};

export default chat;
